import { Component, OnInit } from '@angular/core';
import { ProjectBuilderService } from '../project-builder.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ProjectActivitySummaryCardComponent } from '../project-activity-summary-card/project-activity-summary-card.component';

@Component({
  selector: 'app-project-summary',
  templateUrl: './project-summary.component.html',
  styleUrls: ['./project-summary.component.scss'],
  imports: [TranslateModule, CommonModule, ProjectActivitySummaryCardComponent]
})
export class ProjectSummaryComponent implements OnInit {

  public activities$;

  constructor(
    private projectBuilderService: ProjectBuilderService
  ) { }

  ngOnInit() {
    this.activities$ = this.projectBuilderService.getActivities();
  }

}
